import { langKey } from "@/i18n";

const adConfig: Record<string, Record<string, any>> = {};
const domainMap: Record<string, string[]> = {};
const domains: string[] = [];
const adMap: Record<string, any> = {};

const modules = import.meta.glob("./modules/*.ts", {
  import: "default",
  eager: true,
});

Object.keys(modules).forEach(key => {
  const filename = key.split("/").pop()?.replace(".ts", "");
  if (typeof filename === "string" && !adConfig[filename]) {
    const module = modules[key] as Record<string, any>;
    if (module && typeof module === "object" && Object.keys(module).length > 0) {
      domainMap[filename] = [];
      domainMap[filename].push(...Object.keys(module));
      domains.push(...Object.keys(module));
      adConfig[filename] = module;
      Object.keys(module).forEach(key => {
        adMap[key] = module[key];
      });
    }
  }
});

console.table({
  adConfig,
  adMap,
  domainMap,
  domains,
  langKey,
});
export { adConfig, domainMap, domains, adMap };
